/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Coinvestments_Indicateinterest_Successmessage3Inputs */

const en_coinvestments_indicateinterest_successmessage3 = /** @type {(inputs: Coinvestments_Indicateinterest_Successmessage3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have submitted an indicative order of ${i?.amount}`)
};

/**
* | output |
* | --- |
* | "You have submitted an indicative order of {amount}" |
*
* @param {Coinvestments_Indicateinterest_Successmessage3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_indicateinterest_successmessage3 = /** @type {((inputs: Coinvestments_Indicateinterest_Successmessage3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Indicateinterest_Successmessage3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_indicateinterest_successmessage3(inputs)
});
export { coinvestments_indicateinterest_successmessage3 as "coInvestments_indicateInterest_successMessage" }